module.exports = __webpack_public_path__ + "static/media/icons-ic-dispositions-closed-lead.2d8e8715.svg";